import { render, staticRenderFns } from "./showDocument.vue?vue&type=template&id=007d73e1&scoped=true"
import script from "./showDocument.vue?vue&type=script&lang=js"
export * from "./showDocument.vue?vue&type=script&lang=js"
import style0 from "./showDocument.vue?vue&type=style&index=0&id=007d73e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d73e1",
  null
  
)

export default component.exports